import { render, staticRenderFns } from "./service-unavaliable.vue?vue&type=template&id=ccb12c70&scoped=true"
import script from "./service-unavaliable.vue?vue&type=script&lang=ts"
export * from "./service-unavaliable.vue?vue&type=script&lang=ts"
import style0 from "./service-unavaliable.vue?vue&type=style&index=0&id=ccb12c70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb12c70",
  null
  
)

export default component.exports